import { CountUp } from "countup.js";
import { gsap } from "gsap";
import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";

const runCounter = (el) => {
  const useGrouping = el.dataset.useGrouping;
  const decimalPlaces = el.dataset.decimalPlaces;
  const end = el.dataset.end;

  const opts = {
    useGrouping: !!+useGrouping,
  };

  if (decimalPlaces) {
    opts.decimalPlaces = decimalPlaces;
  }

  const counter = new CountUp(el, end, opts);

  counter.start();
};

const animateItem = (item) => {
  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    if (!item.classList.contains("did-count")) {
      const counterEl = item.querySelector("[data-counter]");
      if (counterEl) {
        runCounter(counterEl);
      }
      item.classList.add("did-count");
    }
  }

  gsap.fromTo(
    item.querySelectorAll("*"),
    {
      opacity: 0,
      y: "10%",
    },
    {
      opacity: 1,
      y: 0,
      stagger: 0.1,
    },
  );
};

document.querySelectorAll(".element-stats").forEach((el) => {
  const container = el.querySelector(".swiper");

  const init = () => {
    new Swiper(container, {
      modules: [A11y, Autoplay, EffectFade, Navigation, Pagination],
      autoplay: {
        delay: 5000,
      },
      loop: true,
      speed: 1,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: el.querySelector(".slider-button-next"),
        prevEl: el.querySelector(".slider-button-prev"),
      },
      pagination: {
        el: el.querySelector(".slider-pagination"),
        clickable: true,
      },
      slidesPerView: 1,
      on: {
        init: () => {
          const targetItem = el.querySelector('.stats-item[data-index="1"]');

          animateItem(targetItem);
        },
        slideChange: (swiper) => {
          const index = swiper.realIndex + 1;
          const targetItem = el.querySelector(`.stats-item[data-index="${index}"]`);

          animateItem(targetItem);

          const paginationIndex = index.toString().padStart(2, "0");
          el.querySelector(".custom-pagination span:first-child").textContent = paginationIndex;
        },
      },
    });
  };

  const observer = new IntersectionObserver(
    ([e]) => {
      if (e.isIntersecting) {
        init();
        observer.disconnect();
      }
    },
    {
      threshold: [0.7],
    },
  );

  observer.observe(el);
});
